// Design tokens da tela de Automações.
// Referência: .md/DESIGN_UIUX.md (Painel de Configurações).
//
// Linguagem visual:
// - Neutros zinc (#18181b → #a1a1aa) sobre fundo #f4f4f7; roxo (#6d28d9)
//   só como acento — ação primária, seleção, links.
// - Cor semântica comunica estado; nunca decora.
// - Conteúdo em largura total da área principal (sem card/max-width central).
// - Header sticky flat (branco + border-b), sem radius.
// - Hierarquia por cabeçalho de seção (rótulo uppercase fora do cartão).

export const AUTOMACOES_DESIGN = {
  // ---------- shell ----------
  root: 'flex flex-col h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500 overflow-hidden',
  fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
  container: 'w-full px-4 md:px-6 lg:px-8',
  pageBody: 'pb-[120px]',
  scrollBody: 'flex-1 overflow-y-auto min-h-0',

  // ---------- barra de topo ----------
  stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec] flex-shrink-0',
  topbar: 'flex flex-col lg:flex-row lg:items-start gap-4 pt-[18px] pb-[18px]',
  topbarIdentity: 'flex items-start gap-3.5 min-w-0 flex-1',
  iconTile:
    'flex items-center justify-center flex-shrink-0 w-[42px] h-[42px] rounded-[10px] bg-[#ede9fe] text-[#6d28d9]',
  title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
  subtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
  topbarActions: 'flex items-center gap-2.5 flex-shrink-0 flex-wrap lg:pt-[5px]',

  // ---------- editor header (Automacao / Workflow) ----------
  editorRoot: 'h-screen flex flex-col bg-[#f4f4f7] text-[#18181b] overflow-hidden',
  editorHeader:
    'h-14 bg-white border-b border-[#e7e7ec] flex items-center px-4 md:px-5 justify-between shrink-0 z-30',
  editorBack:
    'flex items-center justify-center flex-shrink-0 w-[34px] h-[34px] rounded-lg bg-transparent text-[#71717a] transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b]',
  editorNameInput:
    'font-semibold text-[14px] text-[#18181b] bg-transparent border-none outline-none focus:ring-0 p-0 w-full placeholder:text-[#a1a1aa] truncate',
  editorMeta: 'text-[12px] text-[#a1a1aa]',
  editorDivider: 'w-px h-5 bg-[#e7e7ec]',
  viewToggle:
    'flex items-center bg-[#f4f4f5] rounded-lg p-0.5 mx-4 shrink-0 border border-[#e7e7ec]',
  viewToggleBtn:
    'flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[12px] font-semibold text-[#71717a] transition-colors hover:text-[#18181b]',
  viewToggleBtnActive:
    'flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[12px] font-semibold bg-white text-[#6d28d9] shadow-none border border-[#e7e7ec]',

  // ---------- filtros / toolbar ----------
  toolbar: 'flex flex-wrap items-center gap-2.5 mt-0',
  searchWrap: 'relative',
  searchIcon: 'absolute left-3 top-1/2 -translate-y-1/2 text-[#a1a1aa] pointer-events-none',
  searchInput:
    'w-[200px] box-border h-auto pl-9 pr-3.5 py-[9px] rounded-lg border border-[#d4d4d8] bg-white text-[13px] text-[#18181b] shadow-none transition-colors placeholder:text-[#a1a1aa] hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus-visible:border-[#8b5cf6] focus-visible:ring-2 focus-visible:ring-[#c4b5fd] focus-visible:ring-offset-0 outline-none',
  filterLabel: 'text-[12px] font-semibold text-[#71717a]',
  filterSelect:
    'appearance-none box-border h-auto pl-3 pr-8 py-[9px] rounded-lg border border-[#d4d4d8] bg-white text-[13px] font-medium text-[#18181b] shadow-none transition-colors hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus:ring-2 focus:ring-[#c4b5fd] outline-none cursor-pointer',
  filterSelectIcon: 'absolute right-2 top-1/2 -translate-y-1/2 text-[#a1a1aa] pointer-events-none',
  viewMode:
    'flex items-center bg-[#f4f4f5] p-0.5 rounded-lg border border-[#e7e7ec]',
  viewModeBtn:
    'flex items-center justify-center w-8 h-8 rounded-md text-[#a1a1aa] transition-colors hover:text-[#18181b]',
  viewModeBtnActive:
    'flex items-center justify-center w-8 h-8 rounded-md bg-white text-[#6d28d9] border border-[#e7e7ec]',

  // ---------- cabeçalho de seção ----------
  sectionHeader: 'mt-[18px] first:mt-0 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3',
  sectionHeaderMain: 'min-w-0',
  sectionHeaderTitle: 'text-[13px] font-bold uppercase tracking-[0.06em] text-[#a1a1aa]',
  sectionHeaderSub: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5]',

  // ---------- cartões ----------
  stack: 'flex flex-col gap-3.5',
  card: 'bg-white border border-[#e7e7ec] rounded-[12px] p-[26px] overflow-hidden min-w-0',
  cardFlush: 'bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0',
  cardRows: 'bg-white border border-[#e7e7ec] rounded-[12px] px-[26px] py-2 overflow-hidden min-w-0',
  cardTitle: 'text-[15px] font-semibold text-[#18181b]',
  cardSubtitle: 'mt-0.5 text-[13px] text-[#71717a] leading-[1.5]',
  divider: 'h-px bg-[#f0f0f3]',

  // ---------- card de automação ----------
  autoGrid: 'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3.5',
  autoCard:
    'group relative flex flex-col gap-3 cursor-pointer p-[18px] bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0 transition-colors hover:border-[#a78bfa]',
  autoCardTitle:
    'text-[14px] font-semibold text-[#18181b] truncate group-hover:text-[#5b21b6] transition-colors',
  autoCardDate: 'text-[12px] text-[#a1a1aa] capitalize',
  autoCardFooter: 'flex items-center justify-between pt-3 mt-auto border-t border-[#f0f0f3]',
  flowRow: 'flex items-center gap-2 text-[12px] min-w-0',
  flowChip:
    'inline-flex items-center justify-center px-2.5 py-1.5 rounded-md bg-[#ede9fe] text-[#5b21b6] border border-[#ddd6fe] text-[12px] font-semibold min-w-0 max-w-[140px] truncate',
  flowChipAlt:
    'inline-flex items-center justify-center px-2.5 py-1.5 rounded-md bg-[#f4f4f5] text-[#52525b] border border-[#e7e7ec] text-[12px] font-semibold min-w-0 max-w-[140px] truncate',
  flowArrow: 'text-[#d4d4d8] flex-shrink-0',

  // ---------- grupo (disclosure) ----------
  groupCard: 'bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0 mb-3.5',
  groupHeader:
    'w-full flex items-center justify-between gap-3 px-[18px] py-4 text-left cursor-pointer transition-colors hover:bg-[#fafafb] min-w-0 border-b border-[#f0f0f3]',
  groupCaret: 'text-[11px] text-[#a1a1aa] w-2.5 flex-shrink-0 transition-transform',
  groupCaretOpen: 'rotate-90',
  groupIcon:
    'flex items-center justify-center w-8 h-8 rounded-lg bg-[#ede9fe] text-[#6d28d9] flex-shrink-0',
  groupTitle: 'text-[14px] font-semibold text-[#18181b]',
  groupBody: 'p-[18px]',
  groupEmpty: 'py-8 text-center text-[13px] text-[#a1a1aa]',

  // ---------- formulário ----------
  field: 'min-w-0',
  label: 'block text-[13px] font-semibold text-[#18181b] mb-[7px]',
  hint: 'mt-[7px] text-[12px] text-[#a1a1aa] leading-[1.5]',
  input:
    'w-full box-border h-auto px-3.5 py-[11px] rounded-lg border border-[#d4d4d8] bg-white text-[14px] md:text-[14px] text-[#18181b] shadow-none transition-colors placeholder:text-[#a1a1aa] hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus-visible:border-[#8b5cf6] focus-visible:ring-2 focus-visible:ring-[#c4b5fd] focus-visible:ring-offset-0',

  // ---------- toggle ----------
  switch: 'flex-shrink-0 data-[state=checked]:bg-[#6d28d9] data-[state=unchecked]:bg-[#d4d4d8]',

  // ---------- botões ----------
  primaryButton:
    'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(124,58,237,.32)] transition-colors hover:from-[#7c3aed] hover:to-[#6d28d9] disabled:from-[#e4e4e7] disabled:to-[#e4e4e7] disabled:text-[#a1a1aa] disabled:shadow-none disabled:cursor-not-allowed',
  ghostButton:
    'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#52525b] whitespace-nowrap transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b] disabled:opacity-50 disabled:cursor-not-allowed',
  dangerButton:
    'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#b42318] whitespace-nowrap transition-colors hover:bg-[#fef3f2] hover:border-[#fecdca] disabled:opacity-50 disabled:cursor-not-allowed',
  iconButton:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#71717a] transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b]',
  iconButtonDanger:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#b42318] transition-colors hover:bg-[#fef3f2] hover:border-[#fecdca]',
  link: 'text-[13px] font-semibold text-[#6d28d9] transition-colors hover:text-[#5b21b6] hover:underline',
  folderButton:
    'inline-flex items-center gap-1.5 h-7 px-2 rounded-md text-[12px] font-medium text-[#71717a] transition-colors hover:text-[#6d28d9] hover:bg-[#ede9fe]',

  // ---------- badges ----------
  badge:
    'inline-flex items-center gap-1.5 px-2.5 py-[3px] rounded-md text-[12px] font-semibold whitespace-nowrap flex-shrink-0 border',
  badgeOk: 'bg-[#ecfdf3] text-[#067647] border-[#abefc6]',
  badgeNeutral: 'bg-[#f4f4f5] text-[#71717a] border-[#e7e7ec]',
  badgeSoft: 'bg-[#ede9fe] text-[#5b21b6] border-[#ddd6fe]',
  badgeDot: 'w-1.5 h-1.5 rounded-full',
  badgeDotOk: 'bg-[#17b26a]',
  badgeDotNeutral: 'bg-[#d4d4d8]',

  // ---------- tabela ----------
  tableWrap: 'w-full overflow-x-auto min-w-0',
  tableHead: 'text-[12px] font-semibold uppercase tracking-[0.04em] text-[#a1a1aa]',
  tableCell: 'text-[14px] text-[#18181b]',
  tableCellMuted: 'text-[13px] text-[#71717a]',
  tableRow: 'border-b border-[#f0f0f3] last:border-b-0 hover:bg-[#fafafb]',

  // ---------- empty / dialog ----------
  emptyState: 'px-2 py-10 text-center',
  emptyIcon:
    'mx-auto mb-4 flex items-center justify-center w-14 h-14 rounded-[12px] bg-[#f4f4f5] text-[#a1a1aa]',
  emptyTitle: 'text-[15px] font-semibold text-[#18181b]',
  emptyDesc: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5] max-w-sm mx-auto',
  dialogTitle: 'text-[15px] font-semibold text-[#18181b]',
  dialogDesc: 'text-[13px] text-[#71717a] leading-[1.5]',
  dialogFooter: 'flex justify-end gap-2.5',
};

export default AUTOMACOES_DESIGN;
